// Désactive `console.log`, `console.debug` et `console.info` en production
// pour ne pas exposer les détails internes de l'app aux utilisateurs finaux.
// On conserve `console.warn` et `console.error` afin que les outils de
// monitoring (Sentry, navigateur DevTools) puissent toujours capturer
// les anomalies graves.
//
// Référence rapport revue : "38 production console statements" — remplacé
// par un no-op global plutôt qu'un remplacement manuel sur 38 fichiers.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}
